<template>
  <div class="personal" id="personal">
    <x-tab v-model="tabIndex" :data="tabList" />
    <div class="tip-info" v-if="noConfirm">
      首次通过统一认证进入本平台时需要进行信息确认，确认后即可进入本平台； 如账号信息有误，请前往
      <u class="link" @click="goLink">{{ certificationInfo.backText }}</u
      >进行修改。
    </div>
    <div class="user-info" v-if="tabIndex == 0">
      <div class="title">
        <!-- <img src="~_img/common/info1.png" alt=""> -->
        <svg-icon :icon-class="'center-card'" />
        <span>个人信息</span>
      </div>
      <div class="content">
        <div class="avatar">
          <!-- <div class="t1">编辑</div> -->
          <UploadBox v-model="avatarInfo" @beforeUpload="uploadAvatar" />
        </div>
        <ul class="info" v-if="userInfo">
          <li v-for="(item, i) in list" :key="item.title">
            <div class="left">
              <div class="t1">
                <i></i>
                <span>{{ item.title }}</span>
              </div>
              <div class="t2">{{ userInfo[item.content] || item.default || '-' }}</div>
            </div>
            <div class="right">
              <IviewButton v-if="item.btn && aiShow" v-show="!item.code || item.code && $permission(item.code)" cusType="secondary" @click="editClick(item.btn)">{{
                item.btn
              }}</IviewButton>
            </div>
          </li>
          <li class="orang-info">
            <div class="head">
              <i></i>
              <span>组织信息</span>
            </div>
            <div class="orang-list">
              <OrganCard :data="item" v-for="(item, i) in organList" :key="i" :active="item.active" />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="tabIndex" v-dom="tabList[tabIndex].comp"></div>
    <IviewModal
      @on-ok="save"
      v-model="modal.show"
      @on-cancel="modal.show = false"
      type="confirm"
      :title="modal.title"
      @on-visible-change="closeDialog"
    >
      <!--  -->
      <Form ref="form" :model="form" :rules="ruleValidate" v-if="modal.title == '修改用户名'">
        <FormItem prop="displayName" label="真实姓名" required>
          <IviewInput v-model="form.displayName" placeholder="请输入" />
        </FormItem>
      </Form>
      <Form ref="form" :model="form" :rules="ruleValidate" v-else-if="modal.title == '修改手机号'">
        <FormItem prop="phone" label="手机号" required>
          <IviewInput v-model="form.phone" placeholder="请输入" />
        </FormItem>
        <FormItem prop="code1" label="验证码" class="check-code">
          <IviewInput v-model="form.code1" placeholder="请输入" />
          <span class="code" @click="codeClick">{{ code }}</span>
        </FormItem>
        <FormItem prop="code" label="动态验证码">
          <IviewInput v-model="form.code" placeholder="请输入" />
          <IviewButton style="margin-left: 20px" @click="sendMsg(2)" v-if="noSend">发送验证码</IviewButton>
          <span style="margin-left: 20px" v-else>{{ time }}</span>
        </FormItem>
      </Form>
      <Form ref="form" :model="form" :rules="ruleValidate" v-else-if="modal.title == '修改密码' && caoType == 1">
        <FormItem prop="oldPass" label="旧密码" required>
          <IviewInput v-model="form.oldPass" placeholder="请输入" />
        </FormItem>
        <FormItem prop="newPass" label="新密码" required>
          <IviewInput v-model="form.newPass" placeholder="请输入" />
        </FormItem>
        <FormItem prop="cPass" label="确认密码" required>
          <IviewInput v-model="form.cPass" placeholder="请输入" />
        </FormItem>
        <!-- <div class="forgetPass" @click="caoType = 2">忘记密码?</div> -->
      </Form>
      <Form ref="form" :model="form" :rules="ruleValidate" v-else-if="modal.title == '修改密码' && caoType == 2">
        <FormItem label="手机号">
          {{ userInfo.userName }}
        </FormItem>
        <FormItem prop="newPass" label="新密码" required>
          <IviewInput v-model="form.newPass" placeholder="请输入" />
        </FormItem>
        <FormItem prop="cPass" label="确认密码" required>
          <IviewInput v-model="form.cPass" placeholder="请输入" />
        </FormItem>
        <FormItem prop="code" label="动态验证码">
          <IviewInput v-model="form.code" placeholder="请输入" />
          <IviewButton style="margin-left: 20px" @click="sendMsg(3)" v-if="noSend">发送验证码</IviewButton>
          <span style="margin-left: 20px" v-else>{{ time }}</span>
        </FormItem>
        <div class="forgetPass" @click="caoType = 1">通过密码重设</div>
      </Form>
      <Form ref="form" :model="form" :rules="ruleValidate" v-else-if="modal.title == '修改邮箱'">
        <FormItem prop="email" label="邮箱" required>
          <IviewInput v-model="form.email" placeholder="请输入" />
        </FormItem>
      </Form>
    </IviewModal>

    <div class="confirm-info" v-if="noConfirm">
      <IviewButton class="t1" @click="confirmInfo">确认以上信息</IviewButton>
    </div>
  </div>
</template>

<script>
import { checkPhone, checkEmail, getCode } from '@/utils/check'
import { getUserInfo, loginMethod } from '@/utils/common'
import { getHtml } from '@/utils'
import OrganCard from '@/views/common/organCard.vue'
export default {
  name: 'personal',
  components: { OrganCard },
  data() {
    return {
      noConfirm: false, //是否确认信息
      certificationInfo: this.$root.certificationInfo,
      code: getCode(),
      caoType: 1, //修改密码类型,1:密码 2:手机号
      avatarInfo: {},
      tabList: [{ label: '个人信息', value: 0 }],
      form: {
        code1: ''
      },
      noSend: true,
      time: 59,
      userInfo: null,
      tabIndex: 0,
      ruleValidate: {
        displayName: [
          {
            required: true,
            message: '请输入真实姓名',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback, source, options) => {
              if (value) {
                if (!checkPhone(value)) {
                  callback('手机号有误')
                } else {
                  this.$api.user.getUserAll({ userName: value }).then((res) => {
                    if (res.data.records.length > 0) callback('手机号已存在')
                    else callback()
                  })
                }
              } else {
                callback('请输入手机号')
              }
            }
          }
        ],
        oldPass: [
          {
            required: true,
            message: '请输入旧密码',
            trigger: 'blur'
          }
        ],
        newPass: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur'
          }
        ],
        cPass: [
          {
            required: true,
            // message: '请输入确认密码',
            trigger: 'blur',
            validator: (rule, value, callback, source, options) => {
              if (value) {
                if (value != this.form.newPass) {
                  callback('两次密码不一致!')
                } else {
                  callback()
                }
              } else {
                callback('请确认密码')
              }
            }
          }
        ],
        email: [
          {
            // required: true,
            trigger: 'blur',
            validator: (rule, value, callback, source, options) => {
              if (value) {
                if (!checkEmail(value)) {
                  callback('邮箱格式错误')
                } else {
                  this.$api.user.checkUser({ email: value }).then((res) => {
                    if (res.data.email) callback('邮箱已存在')
                    else callback()
                  })
                }
              } else {
                callback('请输入邮箱')
              }
            }
          }
        ],
        code1: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, value, callback, source, options) => {
              if (value == this.code.toLocaleLowerCase() || value == this.code) {
                callback()
              } else {
                callback('验证码有误')
              }
            }
          }
        ],
        code: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入动态验证码'
          }
        ]
      },
      list: [
        { title: '真实姓名', btn: '修改用户名', content: 'displayName', code: 'person-editName' },
        { title: '手机号码', btn: '', content: 'mobile' },
        { title: '密码', btn: '修改密码', content: 'password', default: '******', code: 'person-editPsw' },
        { title: '邮箱', btn: '修改邮箱', content: 'email', code: 'person-editMail' }
        // { title: '所属企业', content: 'dep' },
        // { title: '归属部门', content: 'dep' },
        // { title: '角色', content: 'role' }
      ],
      modal: {
        show: false,
        title: ''
      },
      aiShow: true,
      organList: []
    }
  },
  async created() {
    console.log(this.$root.api, '==r');
    let list = this.$root.personList
    list && this.tabList.push(...list)
    this.getInfo()
    this.getOrganInfo()
    this.aiShow = await loginMethod(this.$root.platform)
  },
  methods: {
    closeDialog(show) {
      if (!show) {
        this.$refs.form.resetFields()
      }
    },
    async getOrganInfo() {
      let { id } = await getUserInfo()
      let res = await this.$api.config.getOrganSelect({ userId: id })
      this.organList = res.data.map((item) => ({
        ...item,
        active: item.belongGroup == 1,
        role: (item.roles || []).map((item) => item.roleName).join(','),
        dep: (item.deptGroups || []).map((item) => item.groupName).join(',')
      }))
    },
    async getInfo() {
      let data = await getUserInfo(true)
      let { roleInfo, groupInfo, auditStatus, belongSystem } = data
      // belongSystem  0是其他平台,1是本平台
      this.noConfirm = auditStatus == 0 && belongSystem != 1
      this.userInfo = {
        ...data
        // role: roleInfo?.length ? roleInfo.map((item) => item.roleName).join() : '',
        // dep: groupInfo ? groupInfo[0].title : ''
      }
      // 获取用户头像
      this.$api.user.getAvatar({ userId: this.userInfo.id }).then((res) => {
        this.avatarInfo = { url: res.data[0].attributeContent }
      })
    },
    editClick(val) {
      this.modal.title = val
      this.modal.show = true
      this.form = {}
    },
    sendMsg(type) {
      this.form.phone = this.form.phone || this.userInfo.userName
      if (this.form.phone && this.form.phone != '') {
        this.$api.user.sendTxMsg({ phone: this.form.phone, type }).then((res) => {
          this.noSend = false
          let timer = setInterval(() => {
            if (this.time == 0) {
              this.noSend = true
              this.time = 59
              clearInterval(timer)
            } else {
              this.time--
            }
          }, 1000)
        })
      } else {
        this.$Message.warning('请输入手机号')
      }
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.modal.title == '修改手机号') {
            this.$api.user.setPhone(this.form).then((res) => {
              if (res.data) {
                this.saveApi({ userName: this.form.phone, mobile: this.form.phone })
              } else {
                this.$Message.warning('验证码错误')
              }
            })
          } else if (this.modal.title == '修改密码' && this.caoType == 1) {
            this.$api.user.checkPass({ password: this.form.oldPass }).then((res) => {
              if (Boolean(res.data)) {
                this.saveApi({ password: this.form.cPass })
              } else {
                this.$Message.warning('原密码不正确')
              }
            })
          } else if (this.modal.title == '修改密码' && this.caoType == 2) {
            this.$api.user.setPass({ ...this.form, phone: this.userInfo.userName }).then((res) => {
              if (res.data) {
                this.saveApi({ password: this.form.cPass })
              } else {
                this.$Message.warning('验证码错误')
              }
            })
          } else {
            this.form.password = this.form.cPass
            this.saveApi(this.form)
          }
        }
      })
    },
    saveApi(params) {
      this.$api.user.putUser({ ...this.userInfo, ...params }, [this.userInfo.id]).then((res) => {
        this.$Message.success('操作成功')
        this.getInfo()
        this.modal.show = false
      })
    },
    uploadAvatar(file) {
      this.$api.user.putAvatar({ attributeContent: file.url }, [this.userInfo.id]).then((res) => {})
    },
    confirmInfo() {
      let { id } = this.userInfo
      this.$api.user.putUser({ ...this.userInfo, auditStatus: 1 }, [id]).then((res) => {
        window.location.replace(window.location.origin + '/#/home')
        setTimeout(() => {
          window.location.reload()
        }, 50)
      })
    },
    // 跳转源平台
    goLink() {
      window.location.replace(this.certificationInfo.backLink)
      // window.open('https://h3c.8800.org:1700/#/appStore')
    },
    // 刷新验证码
    codeClick() {
      this.code = getCode()
    }
  },
  directives: {
    dom(el, data) {
      if (data.value) {
        let dom = getHtml(data.value)
        el.innerHTML = ''
        el.appendChild(dom)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.ivu-form {
  margin-left: 40px;

  /deep/ .ivu-form-item-label {
    width: 100px;
  }

  /deep/ .ivu-form-item-error-tip {
    left: 40px;
  }
}
/deep/.ivu-modal-content {
  height: 400px !important;
}
</style>
<style lang="less" scoped>
.personal {
  background: #fff;
  height: 100%;

  .user-info {
    margin: 20px auto 0;
    position: relative;
    height: calc(100% - 90px);
    // height: calc(100vh - 190px);
    overflow: auto;
    padding: 20px 0 0 170px;
    /* 设置滚动条整体，宽高 */

    &::-webkit-scrollbar {
      width: 8px;
    }

    /* 设置滚动条的轨道 */

    &::-webkit-scrollbar-track {
      background: rgba(241, 242, 246, 0.7);
      border-radius: 2px;
    }

    /* 设置滚动条里面的小方块 */

    &::-webkit-scrollbar-thumb {
      background: #e0e5ec;
      border-radius: 8px;
    }

    .title {
      font-size: 20px;
      color: #333;
      display: flex;
      align-items: center;
      img {
        width: 34px;
        margin-right: 4px;
      }
      .svg-icon {
        width: 34px;
        height: 26px;
        margin-right: 7px;
      }
    }

    .content {
      margin-top: 40px;
      display: flex;

      .avatar {
        width: 120px;
        height: 120px;
        position: relative;
        cursor: pointer;
        .t1 {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          font-size: 14px;
          text-align: center;
          line-height: 120px;
          color: #fff;
          letter-spacing: 2px;
          text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
          background: rgba(0, 0, 0, 0.5);
          border-radius: 50%;
        }
      }

      .info {
        margin-left: 50px;

        li {
          width: 1120px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 16px;
          border-bottom: 2px solid #eceef0;
          margin-bottom: 16px;

          .left {
            .t1 {
              display: flex;
              align-items: center;
              font-size: 14px;
              font-weight: bold;
              color: #333;

              i {
                width: 3px;
                height: 13px;
                background: linear-gradient(
                  270deg,
                  rgba(var(--theme-color-rgb), 0.5) 0%,
                  rgba(var(--theme-color-rgb), 1) 100%
                );
                box-shadow: 1px 1px 1px 0px rgba(var(--theme-color-rgb), 0.5);
                border-radius: 2px;
                margin-right: 6px;
              }
            }

            .t2 {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.65);
              margin-top: 4px;
              margin-left: 8px;
            }
          }
        }
        li.orang-info {
          display: block;
          width: 1200px;
          .head {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: bold;
            color: #333;

            i {
              width: 3px;
              height: 13px;
              background: linear-gradient(
                270deg,
                rgba(var(--theme-color-rgb), 0.5) 0%,
                rgba(var(--theme-color-rgb), 1) 100%
              );
              box-shadow: 1px 1px 1px 0px rgba(var(--theme-color-rgb), 0.5);
              border-radius: 2px;
              margin-right: 6px;
            }
          }
          .orang-list {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            max-height: 300px;
            overflow: auto;
            margin-right: 100px;
            padding: 15px;
            margin: 0 0 -15px -15px;
          }
        }
      }
    }
  }

  .tip-info {
    width: 1720px;
    margin: 20px auto 0;
    height: 48px;
    line-height: 48px;
    padding-left: 60px;
    background: rgba(191, 91, 88, 0.1);
    border-radius: 1px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333;

    .link {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #1a45b8;
      margin: 0 4px;
      cursor: pointer;
    }
  }

  .confirm-info {
    text-align: center;
    margin-top: 16px;
  }
  .check-code {
    position: relative;
    .code {
      position: absolute;
      right: 120px;
      top: 50%;
      transform: translateY(-50%);
      background: lightblue;
      width: 100px;
      height: 100%;
      text-align: center;
      font-size: 20px;
      font-style: italic;
      letter-spacing: 3px;
      font-weight: bold;
      color: rgb(73, 173, 31);
      user-select: none;
      cursor: pointer;
    }
  }
  .forgetPass {
    display: inline-block;
    margin-left: 50px;
    margin-top: 10px;
    // position: absolute;
    // top: 250px;
    // left: 100px;
    cursor: pointer;
    color: #515cf3;
  }
}
</style>
